module.exports = __webpack_public_path__ + "static/img/dlog.bea44cb1.png";